import React from 'react';
import classNames from 'classnames';
import { format } from 'date-fns';
import _ from 'lodash';
import AddLogButton from './AddLogButton';
import TimeLog from './TimeLog';
import WatermarkHoliday from '../../../../assets/images/watermark_holiday.svg';
import WatermarkVacation from '../../../../assets/images/watermark_vacation.svg';
import type { Holiday, Log, Project, User } from '../../../types';

type Props = {
  onOpenAddModal: (date: string) => void,
  onOpenEditModal: (log: Log, date: string) => void,
  logsById: { [k: string]: Log },
  logIds: Array<string | number>,
  projects: Array<Project>,
  selectedDate: string,
  holidays: Array<Holiday>,
  selectedUserVacationDates: Array<string>,
  currentUser?: User,
}

const DayColumn = (props: Props) => {
  const {
    onOpenAddModal,
    onOpenEditModal,
    logsById,
    logIds,
    projects,
    selectedDate,
    holidays,
    selectedUserVacationDates,
    currentUser,
  } = props;
  const dailyTotal = _.sum(logIds.map(logId => _.toNumber(logsById[logId].time_spent)));
  const dailyTotalParsed = parseFloat(dailyTotal).toFixed(2);
  const isHoliday = holidays.filter(holiday => holiday.date === selectedDate).length > 0;
  const isVacation = selectedUserVacationDates.filter(vacation => vacation === selectedDate).length > 0;
  const dayName = format(new Date(selectedDate), 'EEE');
  const isWorkday = dayName !== 'Sat' && dayName !== 'Sun' && !isHoliday && !isVacation;
  const hoursMissing = dailyTotal < 8;

  return (
    <div className="col table-bordered text-center">
      <div className={`total-hours text-center ${isWorkday && hoursMissing ? 'hours-missing' : ''}`}>
        <h5>{`Hours: ${dailyTotal.toString().length >= 4 ? dailyTotalParsed : dailyTotal}h`}</h5>
      </div>
      <div className={classNames("billable", { 'holiday': isHoliday, 'vacation': isVacation })}>
        {isHoliday && (<img className="watermark" src={WatermarkHoliday} alt="holiday" />)}
        {isVacation && (<img className="watermark" src={WatermarkVacation} alt="vacation" />)}
        {logIds.map(logId => (
          <div key={logId}>
            {logsById[logId].project_billable && (
              <TimeLog
                day={{ dateString: selectedDate }}
                onOpenEditModal={onOpenEditModal}
                projects={projects}
                log={logsById[logId]}
                key={logId}
                currentUser={currentUser}
              />
            )}
          </div>
        ))}
      </div>
      <div className="non-billable">
        {logIds.map(logId => (
          <div key={logId}>
            {logsById[logId].project_billable === false && (
              <TimeLog
                day={{ dateString: selectedDate }}
                onOpenEditModal={onOpenEditModal}
                projects={projects}
                log={logsById[logId]}
                key={logId}
                currentUser={currentUser}
              />
            )}
          </div>
        ))}
      </div>
      <AddLogButton onOpenAddModal={onOpenAddModal} id={selectedDate} />
    </div>
  );
};

export default DayColumn;
